'use client';

import type { ReactNode } from 'react';
import { QueryProvider } from '@/lib/query-provider';
import { AuthProvider } from '@/lib/auth/provider';
import { NotificationStreamProvider } from '@/lib/notifications/stream-provider';
import { ToastProvider } from '@/components/shared/toast';
import { DemoModeProvider } from '@/lib/demo/demo-mode-context';
import { DocumentViewerProvider } from '@/components/document-viewer/viewer-context';
import { DocumentViewerPanel } from '@/components/document-viewer/document-viewer-panel';
import { useIdleTimeout } from '@/lib/hooks/useIdleTimeout';

function IdleTimeoutMount() {
  useIdleTimeout();
  return null;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <DemoModeProvider>
          <NotificationStreamProvider>
            <ToastProvider>
              <DocumentViewerProvider>
                <IdleTimeoutMount />
                {children}
                <DocumentViewerPanel />
              </DocumentViewerProvider>
            </ToastProvider>
          </NotificationStreamProvider>
        </DemoModeProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
